// extracted by mini-css-extract-plugin
module.exports = {"root":"ListProjectBanner_root__2ffpA","content":"ListProjectBanner_content__2rOaj","left":"ListProjectBanner_left__kupIl","right":"ListProjectBanner_right__U0Y_0"};